<template>
  <div class="form-input-date-wrapper">
    <b v-if="field && field.label">
      <label :for="`input-${field.name}`">{{ field.label }}</label>
    </b>

    <div class="input-container position-relative mb-3">
      <datepicker
        v-if="field.type === 'date'"
        :class="{ 'is-invalid': error }"
        :format="format"
        :disabled="readonly"
        :highlighted="{ dates: [new Date()] }"
        :input-class="`form-control ${error ? 'parsley-error is-invalid' : ''}`"
        :typeable="false"
        :value="value"
        class="form-date-control w-100"
        placeholder="dd/mm/yyyy"
        @input="onInput"
      ></datepicker>

      <!-- Custom Clear Button (Visible only when date is selected and not readonly) -->
      <span
        v-if="value && !readonly"
        class="date-action-btn clear-btn text-danger"
        title="Clear date"
        @click="clearDate"
      >
        <i class="fa fa-times"></i>
      </span>

      <!-- Calendar Icon (Always visible on the right) -->
      <span class="date-action-btn calendar-btn text-muted">
        <i class="fa fa-calendar"></i>
      </span>

      <div v-if="error" class="invalid-feedback d-block">
        <template v-if="errorMessage">{{ errorMessage }}</template>
        <template v-else>Error has been encountered</template>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  name: "FormInputDate",
  components: {
    Datepicker,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: null,
    },
    value: [String, Date],
    readonly: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: "dd/MM/yyyy",
    },
  },
  methods: {
    onInput(e) {
      this.$emit("input", e ? e.toISOString().substring(0, 10) : null);
    },
    clearDate() {
      this.$emit("input", null);
    },
  },
};
</script>

<style scoped>
.input-container {
  position: relative;
  width: 100%;
}

.form-date-control {
  width: 100%;
}

/* Make right padding inside input so text doesn't overlap icons */
.form-date-control ::v-deep input.form-control {
  padding-right: 55px !important;
}

/* Position action icons inside input field on the right */
.date-action-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
  background: transparent;
  border: none;
  font-size: 14px;
}

.calendar-btn {
  right: 12px;
  pointer-events: none; /* Allows click to pass through to open calendar picker */
}

.clear-btn {
  right: 32px;
  cursor: pointer;
}

.clear-btn:hover {
  opacity: 0.8;
}

/* 🛠️ Fix popup calendar getting cut off on the right side of modals */
.form-date-control ::v-deep .vdp-datepicker__calendar {
  right: 0 !important;
  left: auto !important;
  z-index: 9999 !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}
</style>
